<template>
  <el-dialog v-dialog-drag title="到款信息" :visible.sync="showDialog" width="800px" :destroy-on-close="true" append-to-body :before-close="cancel">
    <el-tabs>
      <el-tab-pane label="普通到款" v-if="paymentsInfo.length">
        <el-carousel indicator-position="outside" height="350px" :autoplay="false">
          <el-carousel-item v-for="item in paymentsInfo" :key="item.id">
            <div style="font-weight: bold;margin-bottom: 10px;margin-top: 10px">到款信息详情</div>
            <el-descriptions :column="2" :labelStyle="{'width':'114px'}" :content-style="{'width':'266px'}" border>
              <el-descriptions-item label="合同编号">
                <el-link :underline="false" v-for="(contractNumber,index) in item.contractNumbers" :key="index" type="primary" @click="openContractDialog(contractNumber)">{{ contractNumber + (index !== item.contractNumbers.length - 1 ? ',' : '') }}</el-link>
              </el-descriptions-item>
              <el-descriptions-item label="客户单位">{{item.invoiceTitle}}</el-descriptions-item>
              <el-descriptions-item label="收款单位">{{item.receivingUnit}}</el-descriptions-item>
              <el-descriptions-item label="发票号码">
                <el-link :underline="false" type="primary" @click="openTicketsDialog(invoiceInfo.id)">{{ invoiceInfo.invoiceNumber}}</el-link>
              </el-descriptions-item>
              <el-descriptions-item label="发票金额">{{invoiceInfo.invoiceAmount}}</el-descriptions-item>
              <el-descriptions-item label="到款金额">{{item.paymentAmount}}</el-descriptions-item>
              <el-descriptions-item label="到款时间">{{item.paymentDate}}</el-descriptions-item>
              <el-descriptions-item label="到款备注">{{item.remark}}</el-descriptions-item>
            </el-descriptions>
          </el-carousel-item>
        </el-carousel>
      </el-tab-pane>
      <el-tab-pane label="认领到款" v-if="claimInfos.length">
        <el-carousel indicator-position="outside" height="350px" :autoplay="false">
          <el-carousel-item v-for="item in claimInfos" :key="item.id">
            <div style="font-weight: bold;margin-bottom: 10px">认领信息详情</div>
            <el-descriptions :column="2" :labelStyle="{'width':'114px'}" :content-style="{'width':'266px'}" border>
              <el-descriptions-item label="认领备注">{{item.remark}}</el-descriptions-item>
              <el-descriptions-item label="认领附件" v-if="item?.['annex']?.['CLAIM_THE_INVOICE_ANNEX']">
                <el-button size="mini" type="primary" icon="el-icon-download" @click="download(item.id,'CLAIM_THE_INVOICE_ANNEX')">下载</el-button>
                <el-button size="mini" type="primary" icon="el-icon-view" @click="preview(item.id,'CLAIM_THE_INVOICE_ANNEX')">预览</el-button>
              </el-descriptions-item>
            </el-descriptions>
            <div style="font-weight: bold;margin-bottom: 10px;margin-top: 10px">到款信息详情</div>
            <el-descriptions :column="2" :labelStyle="{'width':'114px'}" :content-style="{'width':'266px'}" border>
              <el-descriptions-item label="合同编号">
                <el-link :underline="false" v-for="(contractNumber,index) in item.data.contractNumbers" :key="index" type="primary" @click="openContractDialog(contractNumber)">{{ contractNumber + (index !== item.data.contractNumbers.length - 1 ? ',' : '') }}</el-link>
              </el-descriptions-item>
              <el-descriptions-item label="付款单位">{{item.data.invoiceTitle}}</el-descriptions-item>
              <el-descriptions-item label="收款单位">{{item.data.receivingUnit}}</el-descriptions-item>
              <el-descriptions-item label="发票号码">
                <el-link :underline="false" type="primary" @click="openTicketsDialog(item.data.invoiceId)">{{ item.data['invoiceInfoDTO'].invoiceNumber}}</el-link>
              </el-descriptions-item>
              <el-descriptions-item label="发票金额">{{item.data['invoiceInfoDTO'].invoiceAmount}}</el-descriptions-item>
              <el-descriptions-item label="到款金额">{{item.data.paymentAmount}}</el-descriptions-item>
              <el-descriptions-item label="到款时间">{{item.data.paymentDate}}</el-descriptions-item>
              <el-descriptions-item label="到款备注">{{item.data.remark}}</el-descriptions-item>
            </el-descriptions>
          </el-carousel-item>
        </el-carousel>
      </el-tab-pane>
    </el-tabs>
    <contract-details v-if="showContractDetails" :show-dialog="showContractDetails" :select-detail="[ContractDetail]" @submit="close1"></contract-details>
    <tickets-details v-if="showTicketsDetails" :show-dialog="showTicketsDetails" :select-detail="TicketsDetail" @submit="close2"></tickets-details>
    <file-preview v-if="showFile" :show-dialog="showFile" :response="fileInfo" @submit="close"></file-preview>
  </el-dialog>
</template>

<script>

import {attachmentDownload} from "@/api/dilivery/audit";
import {getContractPage} from "@/api/dilivery/sales/contract";
import {getTicketsPage} from "@/api/dilivery/tickets";
import ContractDetails from "@/components/sales/ContractDetails.vue";
import TicketsDetails from "@/components/tickets/TicketsDetails.vue";
import FilePreview from "@/components/file/FilePreview.vue";
import { getDataInLocalStorage } from "@/utils/localStorage";
const baseURL = process.env.VUE_APP_BASE_API

export default {
  name: "PaymentsInfo",
  components: { FilePreview, TicketsDetails, ContractDetails},
  props:{
    showDialog:{
      default:false
    },
    paymentsInfo:{
      default: () => ([])
    },
    claimInfos:{
      default: () => ([])
    },
    invoiceInfo:{
      default:() => ({})
    }
  },
  data() {
    return {
      showFile:false,
      fileInfo:null,
      showContractDetails:false,
      ContractDetail:'',
      showTicketsDetails:false,
      TicketsDetail:'',
    };
  },
  methods: {
    cancel() {
      this.$emit('submit','cancel')
    },
    openContractDialog(contractNumber){
      let param = {}
      let data = {
        "query#contractNumber.EQ":contractNumber
      }
      getContractPage(param,data).then(res=>{
        if(res.code === 200){
          if(res.data.records.length === 0){
            this.$messageUi.error("打开合同详情失败")
          }else{
            this.ContractDetail = res.data.records[0]
            this.showContractDetails = true
          }
        }
      }).catch(error=>{})
    },
    openTicketsDialog(id){
      let param = {}
      let data = {
        "query#id.EQ":id
      }
      getTicketsPage(param,data).then(res=>{
        if(res.code === 200){
          if(res.data.records.length === 0){
            this.$messageUi.error("打开发票详情失败")
          }else{
            this.TicketsDetail = res.data.records[0]
            this.showTicketsDetails = true
          }
        }
      }).catch(error=>{})
    },
    close1(){
      this.$nextTick(() => {
        this.showContractDetails = false
      })
    },
    close2(){
      this.$nextTick(() => {
        this.showTicketsDetails = false
      })
    },
    async download(id, type) {
      try {
        let url = `${baseURL}/audit-info/attachment/${id}/${type}?Authorization=${getDataInLocalStorage("token")}&Current-Role=${getDataInLocalStorage("role")}`
        const elink = document.createElement('a')
        elink.href = url
        document.body.appendChild(elink)
        elink.click()
        document.body.removeChild(elink);
      } catch (error) {
        console.log(error);
      }
    },
    async preview(id,type){
      try {
        this.fileInfo = await attachmentDownload(id,type);
        this.showFile = true
      } catch (error) {
        console.log(error);
      }
    },
    close(){
      this.$nextTick(() => {
        this.showFile = false
      })
      this.fileInfo = null
    },
  }
};
</script>

<style>
</style>
